// extracted by mini-css-extract-plugin
export default {"bubble":"styles__bubble___ayMIe"};